import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import SmartSendItemRules from './SmartSendItemRules';
import P2GContentDropDown from '../../P2GContentDropDown';
import { P2GLink } from '@parcel2go/core-ui';
import { useState } from 'react';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

interface props {
  item: SmartSendItemApiModel;
}

export default function SmartSendItemRulesMenu(props: props) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <P2GContentDropDown
      onOpen={() => setOpen(true)}
      control={
        <P2GLink variant="body2">
          <Trans t={t} i18nKey="MANAGE_RULES_LINK" defaults="Manage<br />Rules" />
        </P2GLink>
      }
      children={open && <SmartSendItemRules item={props.item} />}
    />
  );
}
